import { vec3, vec4, mat4 } from "gl-matrix";

class wRay {
    constructor(origin, direction) {
        this.origin_ = vec3.fromValues(0.0, 0.0, 0.0);
        this.dir_ = vec3.fromValues(0.0, 0.0, 1.0);
        this.indDir_ = vec3.create();

        if (origin !== undefined) {
            vec3.copy(this.origin_, origin);
        }

        if (direction !== undefined) {
            vec3.copy(this.dir_, direction);
        }
        this.updateRay();
    }

    getOrigin() {
        let origin = vec3.create();
        vec3.copy(origin, this.origin_);
        return origin;
    }

    getDirection() {
        let dir = vec3.create();
        vec3.copy(dir, this.dir_);
        return dir;
      //  return this.dir_;
    }

    getInvDirection() {
        let invDir = vec3.create();
        vec3.copy(invDir, this.indDir_);
        return invDir;
       // return this.indDir_;
    }

    setRay(origin, direction) {
        if (origin !== undefined) {
            vec3.copy(this.origin_, origin);
        }
        if (direction !== undefined) {
            vec3.copy(this.dir_, direction);
        }
        this.updateRay();
    }

    updateRay() {
        let tmp = vec3.create();
        vec3.normalize(tmp, this.dir_);
        vec3.copy(this.dir_, tmp);
        for (let i = 0; i < 3; i++) {
            this.indDir_[i] = (Math.abs(this.dir_[i]) > 0.00001) ? (1.0 / this.dir_[i]) : (1.0 / 0.00001);
        }
    }

    evaluateRay(t) {
        var rayPos = vec3.create();
        let dirT = vec3.create();
        vec3.scale(dirT, this.dir_, t);
        vec3.add(rayPos, this.origin_, dirT);
        return rayPos;
    }

    getTransformedRay(matrix) {
        // TODO
        this.updateRay();
    }
}

export { wRay };
